import { ServerAdapterFactory } from './ServerAdapterFactory.js'
import { Constants as C, methods as M } from "./methods.js"

export class journalWorker {

    constructor(id, type) {
        this.options = {
            updatePeriod: 1000,
            interval: 1000,
            maxSize: 1000,
            timeout: 60000
        };
        this.tryCount = 0;
        this.ItemsContainer = {};
        this.ServerAdapter = ServerAdapterFactory.GetAdapterInstance(id, type);
        this.ServerAdapter.reSubscribe = this.reSubscribe.bind(this);
        this.started = false;
    }

    async Subscribe() {
        const pack = {
            requestedPublishingInterval: this.options.interval,
            requestedLifetimeInterval: 0,
            maxNotificationsPerPublish: 0,
            maxSize: 1000
        };
        let options = {
            methodType: C.single,
            method: M.CreateEventSubscription,
            timeout: this.options.timeout,
            pack,
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                this.ServerAdapter.subscriptionId = data.subscriptionId;
                resolve(data)
            })
        });
    }

    async CreateMonitoredEvents(items, subId) {
        if (items.length > 0) {
            return await new Promise(resolve => {
                const pack = {
                    subscriptionId: subId || this.ServerAdapter.subscriptionId,
                    items
                };
                this.ItemsContainer = items;
                const options = {
                    methodType: C.single,
                    method: M.CreateMonitoredEvents,
                    timeout: this.options.timeout,
                    pack,
                }
                this.ServerAdapter.sendRequest(options, data => resolve(data));
            });
        }
    }

    async RefreshEvents() {
        const pack = {
            subscriptionId: this.ServerAdapter.subscriptionId
        };
        const options = {
            methodType: C.single,
            method: M.RefreshEvents,
            timeout: this.options.timeout,
            pack,
        }
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => resolve(data));
        });
    }

    async AcknowledgeEvents(items, comment) {
        if (items.length > 0) {
            const pack = {
                subscriptionId: this.ServerAdapter.subscriptionId
            };
            const recs = [];
            for (let i = 0; i < items.length; i++) {
                recs.push({ eventId: items[i], comment: comment });
            }
            pack['recs'] = recs;
            const options = {
                methodType: C.single,
                method: M.AcknowledgeEvents,
                timeout: this.options.timeout,
                pack,
            };
            return await new Promise(resolve => {
                this.ServerAdapter.sendRequest(options, data => resolve(data));
            });
        }
    }

    GetArchivedEvents() {

    }

    StartWatch() {
        if (this.started)
            return;
        this.started = true;

        const options = {
            methodType: C.intervalStart,
            method: M.PublishEvents,
            interval: this.options.updatePeriod,
            timeout: this.options.timeout,
            updateTrend: true
        };
        this.ServerAdapter.sendRequest(options, data => {
            this.upData(data)
            this.ServerAdapter.continue()
        });
    }

    StopWatch() {
        if (!this.started)
            return;
        this.started = false;

        const options = {
            methodType: C.intervalStop,
            method: M.PublishEvents,
        }
        this.ServerAdapter.sendRequest(options);
    }

    async reSubscribe() {
        //const item = {
        //    type: 'error',
        //    time: new Date().toLocaleString(),
        //    title: 'Передан недействительный код подписки журнала',
        //    text: '2150105088'
        //};
        //$ns.add(item);
        if (this.createMonitoredEvents) {
            this.StopWatch();
            return await this.Subscribe().then(response =>
                this.createMonitoredEvents()
                .then(() => this.onRestore()));
        }
    }

    onRestore() {
        this.StartWatch();
//        const item = {
//            type: 'info',
//            time: new Date().toLocaleString(),
//            title: 'Подписка журнала восстановлена'
////            text: '2150105088 resolved'
//        };
//        $ns.add(item);
    }

    getAsyncArchiveData(params, items) {

    }
    async getArchivedEvents(pack) {
        const options = {
            methodType: C.single,
            method: M.GetArchivedEvents,
            timeout: this.options.timeout,
            pack,
        }
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => resolve(data));
        });
    }

    async DeleteMonitoredEvents(monitoredItemId) {

        const pack = {
            items: [monitoredItemId],
            subscriptionId: this.ServerAdapter.subscriptionId
        };
        const options = {
            methodType: C.single,
            method: M.DeleteMonitoredEvents,
            pack,
        }
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => resolve(data));
        });
    }
}